import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CreateOrganizationUserDto,
  EmailChangeDto,
  OrganizationUserDto,
  PasswordChangeDto,
  UserNameChangeDto,
} from '../entities/organization-user-dto';
import { ParentApiService } from './parent-api-service';

@Injectable({ providedIn: 'root' })
export class OrganizationUsersApiService extends ParentApiService {
  private readonly baseUrl = `${environment.webApiAddress}/api/my-organization/users`;

  constructor(private readonly http: HttpClient) {
    super();
  }

  getUsers(stayOnPageIfError?: boolean): Observable<OrganizationUserDto[]> {
    return this.http.get<OrganizationUserDto[]>(this.baseUrl, { headers: this.headersFor(stayOnPageIfError) });
  }

  createUser(dto: CreateOrganizationUserDto, stayOnPageIfError?: boolean): Observable<string> {
    return this.http.post<string>(this.baseUrl, dto, { headers: this.headersFor(stayOnPageIfError) });
  }

  changeName(id: string, dto: UserNameChangeDto, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/name`, dto, { headers: this.headersFor(stayOnPageIfError) });
  }

  changeEmail(id: string, dto: EmailChangeDto, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/email`, dto, { headers: this.headersFor(stayOnPageIfError) });
  }

  deleteUser(id: string, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, { headers: this.headersFor(stayOnPageIfError) });
  }

  restoreUser(id: string, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/restore`, null, { headers: this.headersFor(stayOnPageIfError) });
  }

  setPassword(id: string, dto: PasswordChangeDto, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/password`, dto, { headers: this.headersFor(stayOnPageIfError) });
  }

  setPremium(id: string, isPremiumUser: boolean, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/premium?is-premium-user=${isPremiumUser}`, null, { headers: this.headersFor(stayOnPageIfError) });
  }
}
